import { defineMessages } from 'react-intl';

export default defineMessages({
  phoneCountryOfOrigin: {
    id: 'phoneInput.countryOfOrigin',
    defaultMessage: 'Phone country of origin',
    description:
      'Used for screen readers to describe the phone country of origin drop down',
  },
});
